module.exports = "/_next/static/images/prefooter-youtube@2x_9aba4b05af2db71d26ca3f039e266f72.webp";